import React, { createContext, useContext, useState, useEffect } from "react";
import { auth } from "../firebase/firebase";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const userFetch = async () => {
    try {
      auth.onAuthStateChanged(async (user) => {
        if (user) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      });
    } catch (e) {
      console.warn(e);
    }
  };

  useEffect(() => {
    userFetch();
  }, []);

  const login = () => {
    setIsAuthenticated(true);
  };

  const logout = () => {
    auth.signOut();
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
